import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class GetterSetterService {
    constructor() {}
    public _isRtl: any;
    set rtl(value: any) {
        this._isRtl = value;
    }
    get rtl(): any {
        return this._isRtl;
    }
}
